<div class="facility-pair" [formGroup]="group">
    <div class="row">
        <div class="col-5">
            <mat-form-field appearance="outline" class="width-100">
                <mat-label>Facility ID</mat-label>
                <input
                    id="input-facility-id"
                    matInput
                    formControlName="paidToFacilityId"
                    required
                    type="text"
                    inputmode="text"
                />
            </mat-form-field>
            @if (facilityIdControl.invalid) {
                @if (facilityIdControl.hasError('required')) {
                    <mat-error>This field is required</mat-error>
                }
                @if (facilityIdControl.hasError('pattern')) {
                    <mat-error>Only letters and numbers are allowed</mat-error>
                }
            }
        </div>

        <div class="col-7">
            <div class="label-row">
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>Label</mat-label>
                    <input id="input-facility-label" matInput formControlName="label" required />
                    @if (labelControl.invalid && labelControl.hasError('required')) {
                        <mat-error>This field is required</mat-error>
                    }
                </mat-form-field>

                @if (showRemove) {
                    <button
                        id="btn-remove-facility"
                        mat-icon-button
                        type="button"
                        class="remove-button"
                        color="warn"
                        (click)="remove.emit()"
                        aria-label="Remove facility"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                }
            </div>
        </div>
    </div>
</div>
